import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as encryptedHotel from "../app/modules/EncryptedHotel/_redux/encryptedHotelRedux";


export const rootReducer = combineReducers({
  auth: auth.reducer,
  encryptedHotel: encryptedHotel.reducer
});

export function* rootSaga() {
  yield all([auth.saga(), encryptedHotel.saga()]);
}
